@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/variables-dark";
@import "../styles/renku_bootstrap_customization.scss";

.primaryAlert {
  --bs-primary-bg-subtle: #{tint-color($primary, 90%)};
}
